export function CosmicBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 bg-cosmic">
      <div className="absolute inset-0 stardust opacity-70" />
    </div>
  );
}
